var Theme = Theme || {};

Theme.MyEmailAlerts = (function ($) {
    let $root;
    let _saveChangesLinkEnabled = true;

    return {
        init: _init
    };

    function _init() {
        $root = $('.js-my-email-alerts');
        if (!$root.length) {
            return;
        }

        _bindSaveChanges();
        _bindDeleteAlert();
        _bindAddEditReveal();
    }

    function _bindSaveChanges() {
        $('body').on('click', '#publicationSaveChanges', function () {
            if (!_saveChangesLinkEnabled) {
                return;
            }

            $(this).addClass('linkDisabled');
            _saveChangesLinkEnabled = false;
            _postJournalData();
            _saveChangesLinkEnabled = true;
        });
    }

    function _bindDeleteAlert() {
        $root.on('click', '.js-delete-email-alert', function () {
            _postDelete($(this).data('alert-id'), $(this).data('update-for'));
        });
    }

    function _bindAddEditReveal() {
        $root.on('click', '.add-alert-link-wrap a[data-reveal-id="journalAddEditDiv"]', function () {
            const alertGroup = $(this).data('alert-group');
            const alertValuePattern = /^(journal|conference)\d+-alertType(\d+)-alertId\d+$/;

            $('#journalAddEditDiv').find('.new-alert-row').each(function () {
                $(this).show();

                let hasValidAlertType = false;

                $(this).find('input[name="journalAlertCheckbox"]').each(function () {
                    const alertValue = alertValuePattern.exec($(this).val());

                    if (!alertValue) {
                        return;
                    }

                    const resourceKind = alertValue[1];
                    const alertTypeId = alertValue[2];

                    const belongsToAlertGroup = alertGroup === 'conference'
                        ? resourceKind === 'conference'
                        : resourceKind === 'journal' && Boolean(alertGroup === 'pap' ^ alertTypeId !== '3');

                    $(this).closest('.new-alert-type').toggle(belongsToAlertGroup);

                    hasValidAlertType = hasValidAlertType || belongsToAlertGroup;
                });

                if (!hasValidAlertType) {
                    $(this).hide();
                }
            });
        });
    }

    function _postJournalData() {
        const selected = [];
        $('#journalAddEditDiv input:checked').each(function () {
            selected.push($(this).val());
        });

        const modelValues = {
            JournalAlertsJson: $('#JournalAlertsJson').val(),
            JournalUpdates: JSON.stringify(selected).toString(),
            SeparateJournalsAlerts: ($('input#Config_SeparateJournalsAlerts').length) ? $('input#Config_SeparateJournalsAlerts').val() : false,
            PublishAheadofPrint_FriendlyName: ($('input#Config_PublishAheadofPrint_FriendlyName').length) ? $('input#Config_PublishAheadofPrint_FriendlyName').val() : "Advance access",
            LatestIssue_FriendlyName: ($('input#Config_LatestIssue_FriendlyName').length) ? $('input#Config_LatestIssue_FriendlyName').val() : "Latest issue",
            InstanceName: ($('input#InstanceName').length) ? $('input#InstanceName').val() : "",
            UpdateFor: $root.data('update-for-publications'),
            EmailAlertsAuthToken: $("#EmailAlertsAuthToken").val()
        };

        $('#journalAddEditDiv .close-reveal-modal').click();

        $.post("/Content/MyEmailAlerts", modelValues, function (data) {
            setTimeout(function () {
                _update(data);

                const showModalAgain = $.trim($('.detect-error-message').html()) !== '';
                if (showModalAgain) {
                    $('#journalAddEditDiv').addClass('open');
                    $('body').addClass('on-canvas');
                }
            }, 200);
        });
    }

    function _postDelete(alertId, updateFor) {
        const modelValues = {
            AlertIdToDelete: alertId,
            UpdateFor: updateFor,
            SeparateJournalsAlerts: ($('input#Config_SeparateJournalsAlerts').length) ? $('input#Config_SeparateJournalsAlerts').val() : false,
            PublishAheadofPrint_FriendlyName: ($('input#Config_PublishAheadofPrint_FriendlyName').length) ? $('input#Config_PublishAheadofPrint_FriendlyName').val() : "Advance access",
            LatestIssue_FriendlyName: ($('input#Config_LatestIssue_FriendlyName').length) ? $('input#Config_LatestIssue_FriendlyName').val() : "Latest issue",
            ShowSyncOnlyAlerts: ($('input#Config_ShowSyncOnlyAlerts').length) ? $('input#Config_ShowSyncOnlyAlerts').val() : false,
            ConfigSiteName: ($('input#Config_ConfigurableSiteName').length) ? $('input#Config_ConfigurableSiteName').val() : "",
            EmailAlertsAuthToken: $("#EmailAlertsAuthToken").val(),
            InstanceName: ($('input#InstanceName').length) ? $('input#InstanceName').val() : ""
        };

        $.post("/Content/MyEmailAlerts", modelValues, function (data) {
            _update(data);
        });
    }

    function _update(data) {
        const $data = $(data);
        $("#EmailAlertsAuthToken").val($data.find("#EmailAlertsAuthToken").val());

        if (_replaceHtmlFromResponse($data, 'div#journalsDetails')) {
            _restoreConfigText('Config_PublicationAlertsLeadText', 'p#publicationAlertsLeadText');
            _restoreConfigText('Config_NoPublicationAlertsText', 'span#noPublicationAlertsText');
        }

        const journalAlertsJson = $data.find('input#JournalAlertsJson').val();
        if (journalAlertsJson && journalAlertsJson.length) {
            $('input#JournalAlertsJson').val(journalAlertsJson);
        }

        _replaceHtmlFromResponse($data, 'div#journalUpdateDetails');
        _replaceHtmlFromResponse($data, '.detect-error-message');

        if (_replaceHtmlFromResponse($data, 'div#topicsDetails')) {
            _restoreConfigText('Config_NoTopicAlertsText', 'span#noTopicAlertsText');
            _restoreConfigText('Config_TopicCollectionAlertsNote', 'p#topicCollectionAlertsNote');
        }

        if (_replaceHtmlFromResponse($data, 'div#contentDetails')) {
            _restoreConfigText('Config_NoContentAlertsText', 'span#noContentAlertsText');
            _restoreConfigText('Config_ContentAlertsNote', 'p#contentAlertsNote');
        }

        if (_replaceHtmlFromResponse($data, 'div#syncOnlyAlertDetails')) {
            _restoreConfigText('Config_NoSyncOnlyAlertsText', 'span#noSyncOnlyAlertsText');
        }

        SCM.SiteJS.modalManager();
    }

    function _replaceHtmlFromResponse($data, selector) {
        const html = $data.find(selector).html();
        if (html && html.length) {
            $(selector).html(html);
            return true;
        }

        return false;
    }

    function _restoreConfigText(configInputId, targetSelector) {
        const original = $('input#' + configInputId).val();
        const $target = $(targetSelector);
        if ($target.length) {
            $target.html(original);
        }
    }
})(jQuery);
